import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { Page } from "types/dto/Page";
import { RegistroContaPagarTabelaGroupPay } from "types/contasPagar/RegistroContaPagarTabelaGroupPay";
import { PaginatedRequest } from "types/request/PaginatedRequest";
import { useQuery } from "react-query";
import { http } from "shared/util/http";

type parametros = PaginatedRequest & {
  valor: string;
  pesquisa?: string;
  mesCompetencia?: string;
  dataVencimento?: string | undefined;
  condominioId?: string;
  cpfCnpjEmissor?: string;
};

export const useGetRegistrosContasPagarTabelaGroupPay = (params: parametros, deveBuscarRegistros: boolean) => {
  const onError = () => {
    toast.error("Erro ao buscar despesas");
  };

  return useQuery<Page<RegistroContaPagarTabelaGroupPay>>({
    queryKey: ["registro-contas-pagar-tabela-group-pay", params],
    queryFn: async () => {
      const resp = await http.get<Page<RegistroContaPagarTabelaGroupPay>>(
        api.contasPagar.getBuscarRegistrosTabelaGroupPay,
        {
          pesquisa: params?.pesquisa,
          mesCompetencia: params?.mesCompetencia,
          dataVencimento: params?.dataVencimento,
          valor: params?.valor,
          cpfCnpjEmissor: params?.cpfCnpjEmissor,
          condominioId: params?.condominioId,
          page: 0,
          size: 9999,
          sort: "",
        }
      );
      return resp.data;
    },
    onError,
    enabled: deveBuscarRegistros,
  });
};
